/**
 * Template for creating new exercises
 */
import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  newExercise: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > div": {
      width: 700,
      maxWidth: "100%",
      background: "#fff",
      padding: 20,
      maxHeight: "100%",
      overflow: "auto",
    },
    "& h3": {
      textAlign: "center",
      color: theme.palette.primary.main,
    },
  },
  action: {
    textAlign: "center",
    verticalAlign: "middle",
    "& button": {
      margin: "0 3px",
      verticalAlign: "middle",
    },
    "& > span": {
      display: "inline-block",
      minWidth: 53,
      verticalAlign: "middle",
      userSelect: "none",
    },
  },
  table: {
    display: "flex",
    justifyContent: "space-between",
    background: "#ccc",
    "& > div": {
      width: "50%",
      boxSizing: "border-box",
      borderRadius: 5,
      "&:first-child": {
        padding: "10px 5px 5px 10px",
      },
      "&:nth-child(2)": {
        padding: "10px 10px 5px 5px",
      },
    },
    "& span": {
      display: "block",
      width: "100%",
      background: "#fff",
      borderRadius: 3,
      marginBottom: 5,
      textAlign: "center",
      lineHeight: 1,
      padding: "0.25em 0.5em",
      position: "relative",
      boxSizing: "border-box",
      color: theme.palette.primary.main,
      fontWeight: 500,
      minHeight: "1.5em",
    },
    "& i": {
      position: "absolute",
      top: 5,
      left: 5,
      color: "#999",
    },
  },
  help1: {
    color: "#666",
    textAlign: "center",
    fontSize: "0.9em",
  },
  words: {
    textAlign: "center",
    "& > span": {
      display: "inline-block",
      whiteSpace: "nowrap",
      background: theme.palette.primary.main,
      borderRadius: 15,
      color: "#fff",
      margin: 5,
      lineHeight: 1,
      padding: "5px 10px",
      cursor: "pointer",
      userSelect: "none",
    },
    "& > span.active": {
      background: theme.palette.secondary.main,
    },
  },
  "@media(max-width: 850px)": {},
}));

let timeout = 0;

function MostUseful(props) {
  const classes = useStyles();

  const { exercise, startStats, finishExercise, action, type, close } =
    props.exerciseProps;
  const [words, setWords] = useState(exercise);
  const [important, setImportant] = useState(new Array(10).fill(""));
  const currentIdx = useRef(0);

  useEffect(() => {
    startStats(type);
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setWords(exercise);
    action();
    // eslint-disable-next-line
  }, [exercise]);

  const finishTest = () => {
    finishExercise();
    props.media.finish();
  };

  const handleClick = (idx) => {
    action();
    const word = words[idx];
    const newImportant = [...important];
    newImportant[currentIdx.current] = word;
    setImportant(newImportant);
    const newWords = [...words];
    newWords.splice(idx, 1);
    setWords(newWords);
    props.media.success();
    currentIdx.current++;
    if (currentIdx.current === 10) {
      timeout = setTimeout(() => {
        finishTest();
      }, 750);
    }
  };

  const clean = () => {
    action();
    currentIdx.current = 0;
    setWords(exercise);
    setImportant(new Array(10).fill(""));
  };

  return (
    <div className={classes.newExercise}>
      <div>
        <h3>
          Które z poniższych słów są wg Ciebie najbardziej użyteczne i dlaczego?
        </h3>
        <div className={classes.table}>
          <div>
            {[0, 1, 2, 3, 4].map((idx) => (
              <span key={idx}>
                <i>{idx + 1}</i> {important[idx]}
              </span>
            ))}
          </div>
          <div>
            {[5, 6, 7, 8, 9].map((idx) => (
              <span key={idx}>
                <i>{idx + 1}</i> {important[idx]}
              </span>
            ))}
          </div>
        </div>
        <p className={classes.help1}>
          Przenieś wybrane wyrazy do tabeli klikając na nie. Zaczynij od tych
          najważniejszych.
        </p>
        {currentIdx.current < 10 && (
          <div className={classes.words}>
            {words.map((word, idx) => (
              <span key={idx} onClick={() => handleClick(idx)}>
                {word}
              </span>
            ))}
          </div>
        )}
        {currentIdx.current === 10 && (
          <div className={classes.action}>
            <Button variant="outlined" color="primary" onClick={clean}>
              Wyczysć
            </Button>
            <Button variant="outlined" color="secondary" onClick={close}>
              Zamknij
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  };
};

export default connect(mapStateToProps)(MostUseful);
